"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBoardClipRoute = exports.createBoardRoute = void 0;
/**
 * Copied from next repo
 */
const sanitizeStringForUrl = (str) => str
    .replace(/[^a-zA-Z0-9 ]/g, ' ')
    .trim()
    .replace(/[ ]+/g, '-')
    .toLowerCase();
const createBoardRoute = (id, title) => `${id === 'root'
    ? '/boards?view=all'
    : `/b/${title ? `${sanitizeStringForUrl(title)}-` : ''}${id}`}`;
exports.createBoardRoute = createBoardRoute;
const createBoardClipRoute = ({ clipId, boardTitle, boardId, }) => {
    const boardRoute = boardId ? (0, exports.createBoardRoute)(boardId, boardTitle) : '';
    const assetRoute = `/c/${clipId}`;
    return `${boardRoute}${assetRoute}`;
};
exports.createBoardClipRoute = createBoardClipRoute;
//# sourceMappingURL=routes.js.map